import { useCallback } from 'react';

import { DYNAMIC_TAG_NAMES } from '@interlayer/js/app/utils/constants';

import { useDynamicTags } from 'js/app/hooks/useDynamicTags';

const EMPTY_CATEGORY_URI = {};

export const useCheckPathAsGameCategory = () => {
    const [dTagCategoryPaths] = useDynamicTags([DYNAMIC_TAG_NAMES.categoryPaths]);

    return useCallback((path) => {
        const categoryPathsArray = dTagCategoryPaths
            ?.split(',')
            .map(str => str.trim())
            .filter(Boolean);

        if (!categoryPathsArray?.length) {
            return EMPTY_CATEGORY_URI;
        }

        const pathnameArray = path.split('/');
        const parentCategory = pathnameArray
            .slice(0, -1)
            .join('/');

        if (!categoryPathsArray.find(categoryPath => [parentCategory, path].includes(categoryPath))) {
            return EMPTY_CATEGORY_URI;
        }

        return {
            gameParentCategory: parentCategory || path,
            gameNameCategory: parentCategory ? decodeURI(pathnameArray[pathnameArray.length - 1]) : ''
        };
    }, [dTagCategoryPaths]);
};

